
import { defineComponent, PropType } from "vue";
import CiImgixLazy from "@components/base/imgix-lazy.vue";

export default defineComponent({
  name: "UserProfileCompany",
  components: { "ci-imgix-lazy": CiImgixLazy },
  props: {
    company: {
      type: Object as PropType<{ name: string; url?: string; logo_url?: string }>,
      required: true,
    },
  },
});
